// Structural, so the same block renders an address from either generated client.
interface PostalAddress {
  company?: string
  first_name?: string
  last_name?: string
  address_line_1?: string
  address_line_2?: string
  postcode?: string
  city?: string
  state_province?: string
  country?: string
  country_code?: string
}

interface WarehouseAddressProps {
  address?: PostalAddress
  className?: string
}

// The shopper copies this onto a parcel, so each element gets its own line. A province that only
// repeats the city is left out, the way Madrid or Milano would read twice otherwise, and a
// warehouse saved with only a country code still shows a country: settings-api lets the name be
// empty but never the code.
export function warehouseAddressLines(address: PostalAddress): string[] {
  const name =
    address.company ||
    [address.first_name, address.last_name].filter(Boolean).join(' ')
  const province =
    address.state_province?.toLowerCase() === address.city?.toLowerCase()
      ? undefined
      : address.state_province

  return [
    name,
    address.address_line_1,
    address.address_line_2,
    [address.postcode, address.city].filter(Boolean).join(' '),
    province,
    address.country || address.country_code
  ].filter((line): line is string => Boolean(line && line.trim()))
}

export const WarehouseAddress: React.FC<WarehouseAddressProps> = ({
  address,
  className
}) => {
  if (!address) return null

  const lines = warehouseAddressLines(address)

  if (lines.length === 0) return null

  return (
    <address
      className={`rounded-md border border-solid border-neutral-200 px-4 py-3 text-sm not-italic ${className ?? ''}`}
    >
      {lines.map((line, index) => (
        <span key={`${index}-${line}`} className="block">
          {line}
        </span>
      ))}
    </address>
  )
}
